import { usePortalView } from './PortalView';
import SegmentedSwitch from './SegmentedSwitch';

// PORTAL_VIEW_V1: a segmented switch in the CRM top bar, in front of the
// Beta / Live switcher (admins). It filters every list in the sidebar (Users,
// Leads, Traces, Searches, Pensions, Documents, Tasks) to one audience:
//   Assisted = main-band clients, Portal = self-serve clients in the portal,
//   Guide = everyone who reached the self-help guide, All = no filter.
// Each person's choice is saved on their own account (see PortalView.jsx).
// Self-serve leads themselves follow Settings > Portal, not this switch.

export const BAND_ROUTES = [
  { value: 'assisted', label: 'Assisted' },
  { value: 'portal', label: 'Portal' },
  { value: 'guide', label: 'Guide' },
  { value: 'all', label: 'All' }
];

export const routeLabel = route => BAND_ROUTES.find(option => option.value === route)?.label || null;

const TITLES = {
  assisted: 'Showing Assisted (main band) only, on every list.',
  portal: 'Showing Portal (self-serve) only, on every list.',
  guide: 'Showing Guide only (everyone who got the self-help guide), on every list.',
  all: 'Showing everyone. Pick Assisted, Portal or Guide to filter every list.'
};

const SecondBandSwitch = () => {
  const { view, setView, saving, error } = usePortalView();
  return (
    <SegmentedSwitch
      options={BAND_ROUTES}
      value={view}
      onChange={setView}
      ariaLabel='Show'
      title={error || TITLES[view]}
      disabled={saving}
      className={`mx-1 ${error ? 'ring-1 ring-danger-300' : ''}`}
    />
  );
};

export default SecondBandSwitch;
